export const REWARD_TYPE_LABELS = {
	CREDIT: 'เครดิต',
	FREE_SPIN: 'ฟรีสปิน',
	ITEM: 'สินค้า',
} as const

export const REWARD_TYPE_VARIANTS = {
	CREDIT: 'default',
	FREE_SPIN: 'secondary',
	ITEM: 'outline',
} as const

export const CURRENCY_TYPE_LABELS = {
	DIAMOND: 'เพชร',
	CREDIT: 'เครดิต',
} as const

export const STATUS_LABELS = {
	active: 'เปิดใช้งาน',
	inactive: 'ปิดใช้งาน',
} as const
